//-----------------
// set race values
//-----------------
export default function setRaceValues(char_default_val, char_default_min, char_default_max) {
  // ----------------------
  // define race structure
  // ----------------------
  let race = {
    //
    id: 0,
    slug: '',
    name: '',
    //
    ca: 0,
    cr: 0,
    sr: 0,
    damage_mod: 0,
    //
    move: 0,
    move_fly: 0,
    //
    str: char_default_val,
    str_min: char_default_min,
    str_max: char_default_max,

    con: char_default_val,
    con_min: char_default_min,
    con_max: char_default_max,
    //
    dex: char_default_val,
    dex_min: char_default_min,
    dex_max: char_default_max,
    //
    siz: char_default_val,
    siz_min: char_default_min,
    siz_max: char_default_max,
    //
    int: char_default_val,
    int_min: char_default_min,
    int_max: char_default_max,
    //
    pow: char_default_val,
    pow_min: char_default_min,
    pow_max: char_default_max,
    //
    cha: char_default_val,
    cha_min: char_default_min,
    cha_max: char_default_max,
    //
    special_action: false,
    special_reaction: false,
    character_race: false,
    //
    image: null,
  }
  return race
}
